<input
  [formControl]="control"
  [type]="type"
  [ngClass]="inputClass"
  [class.with-reset]="reset"
  [ngStyle]="inputStyle"
  [attr.role]="role"
  [attr.inputmode]="type"
  [attr.autocomplete]="autocomplete"
  [attr.aria-autocomplete]="ariaAutocomplete"
  [attr.aria-controls]="ariaControls"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-activedescendant]="ariaActivedescendant"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledBy"
  [attr.aria-describedby]="errorId"
  [attr.aria-invalid]="control.invalid"
  [attr.placeholder]="placeholder"
  [attr.readonly]="readonly()"
  (focus)="handleFocus()"
  (blur)="handleBlur()"
  (keydown)="handleKeydown($event)"
  pluginsFormBaseControlStyle
  pluginsTrim
  #inputRef
/>

@if ((reset || type === 'search') && control.value) {
  <plugins-clear-input [label]="resetLabel" (clear)="onReset()" />
}
